import { DurationPicker } from '@salecycle/ui-component-library';
import { delayUnits, getHowManyAndUnits, HowManyAndUnits, getDelay } from '../../../../../utils/timeUtils';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { maximumDelay } from '../configs/sendConfig';

export interface Props {
  settings: HowManyAndUnits;
  sessionTimeout: HowManyAndUnits;
  onChange: (displayDelay: number, units: string) => void;
}

const options = delayUnits.map(unit => ({
  value: unit,
  label: unit,
}));

export const DelaySelector: React.FC<Props> = props => {
  const { t } = useTranslation('campaigns');
  const [userSettings, setUserSettings] = React.useState(null);
  const [validationState, setValidationState] = React.useState(null);

  const values = userSettings ? userSettings : props.settings;

  const handleDurationChange = (value: number, unit: string) => {
    validateInput(value, unit);
    setUserSettings(getHowManyAndUnits(value, delayUnits[unit]));
    props.onChange(value, unit);
  };

  const validateInput = (value: number, unit: string) => {
    const currentDelay = getDelay(value, unit);

    if (
      currentDelay < getDelay(props.sessionTimeout.howMany, props.sessionTimeout.units) ||
      currentDelay > maximumDelay
    ) {
      setValidationState('warning');
    } else {
      setValidationState('');
    }
  };

  const getValidationMessage = (value: number, unit: string): string => {
    const currentDelay = getDelay(value, unit);
    if (currentDelay < getDelay(props.sessionTimeout.howMany, props.sessionTimeout.units)) {
      return t('campaigns:editor.rulesets.offSiteChannelModal.validationMessageMinimum');
    }
    if (currentDelay > maximumDelay) {
      return t('campaigns:editor.rulesets.offSiteChannelModal.validationMessageMaximum', {
        howMany: 32,
      });
    }
  };

  return (
    <DurationPicker
      tooltipHeading={t('campaigns:editor.rulesets.offSiteChannelModal.input.ariaLabel')}
      tooltipDescription={t('campaigns:editor.rulesets.offSiteChannelModal.tooltipDescription')}
      value={values.howMany}
      onChange={handleDurationChange}
      label={t('campaigns:editor.rulesets.offSiteChannelModal.input.label')}
      unit={t(`campaigns:editor.rulesets.offSiteChannelModal.${values.units}`)}
      ariaLabel={t('campaigns:editor.rulesets.offSiteChannelModal.durationPickerAriaLabel')}
      unitAriaLabel={t('campaigns:editor.rulesets.offSiteChannelModal.durationPickerUnitAriaLabel')}
      units={options}
      validationMessage={getValidationMessage(values.howMany, values.units)}
      validationState={validationState}
    />
  );
};
